"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUsedGalleryImageIds;
const UserPhotoLayer_1 = require("../../models/layers/UserPhotoLayer");
function getUsedGalleryImageIds(project) {
  const galleryImageIds = [];
  project.printableGroups.forEach(pg => {
    pg.printables.forEach(p => {
      p.layers.forEach(l => {
        if ((0, UserPhotoLayer_1.isUserPhotoLayer)(l) && l.userData) {
          galleryImageIds.push({
            galleryId: l.userData.galleryId,
            imageId: l.userData.galleryImageId
          });
        }
      });
    });
  });
  return galleryImageIds;
}